// Single source of truth for "mobile" in the email UI: the preview/editor
// mobile canvas renders at this width, and device-group detection
// (emails/email-editor/device-groups.ts) resolves media queries at it.
// Desktop has no equivalent constant — the desktop canvas renders at full
// container width.
export const MOBILE_PREVIEW_WIDTH_PX = 375;
export const MOBILE_PREVIEW_WIDTH = `${MOBILE_PREVIEW_WIDTH_PX}px`;
